













































































































let vm!: any;
let AMap!: any;
import { Component, Vue, Prop } from 'vue-property-decorator';
import { MapViewModel, MapService } from '../../api/map';
import { MarkViewModel, MarkService } from '../../api/mark';
import { TimelineItemService, TimelineItemViewModel } from '../../api/timelineItem';
import { amapOptions } from './amapOptions';
import { AMapManager } from 'vue-amap';
import { MessageBox } from 'element-ui';
import EditMap from '../Map/edit.vue';
import EditMark from '../Mark/edit.vue';
import FavoriteButton from '../Favorite/FavoriteButton.vue';

@Component({
  components: {
    EditMap,
    EditMark,
    FavoriteButton,
  },
})
export default class MapDetail extends Vue {
  private mapId: number = 0;
  private service: MapService = new MapService();
  private selectMap: MapViewModel = this.service.NewModel;
  private data: MapViewModel[] = [];

  private showDrawer: boolean = true;
  private timelineItemService: TimelineItemService = new TimelineItemService();
  private timelineItemData: any[] = [];
  private timelineItemIDs: number[] = [];
  private loading: boolean = false;
  private showEditMap: boolean = false;
  private showEditMark: boolean = false;
  private showMapList: boolean = false;
  private searchMarks = [];

  private markService: MarkService = new MarkService();
  private markData: MarkViewModel[] = [];
  private amapOptions: any = amapOptions;
  private mapHeight: string = '500px';
  private markListHeight: string = '500px';

  private mapLoaded: boolean = false;
  private amap!: any;
  private isPlay: boolean = false;
  private isPlayed: boolean = false;
  private linePath!: any;
  private moveMakerPosition = [];
  private passedPolyline!: any;
  private infoWindow!: any;
  private lastPathIndex: number = 1;
  private moveMaker!: any;
  private moveMarkerEvents = {
    moving: (e: any) => {
      this.passedPolyline.setPath(e.passedPath);
    },
  };
  private moveSpeed: number = 4;

  private mapEvents: any = {
    init: (o: any) => {
      vm.amap = o;
      AMap = (window as any).AMap;
    },
    complete: (o: any) => {
      vm.passedPolyline = new AMap.Polyline({
          map: vm.amap,
          strokeColor: '#F00',  // 线颜色
          strokeWeight: 6,      // 线宽
      });
      vm.infoWindow = new AMap.InfoWindow({
        content: vm.infoWindowContent.join(''),
        map: vm.amap,
      });
      // vm.loadMark();
    },
    hotspotclick: (result: any) => {
      // var placeSearch = new AMap.PlaceSearch();
      // placeSearch.getDetails(result.id, (status: any, result: any) => {
      //   console.log(result);
      // })
      const geocoder = new AMap.Geocoder();
      geocoder.getAddress(result.lnglat, function(status: any, geocode: any) {
        if (status === 'complete' && geocode.regeocode) {
          let address = geocode.regeocode.formattedAddress.toString();
          address = address.substring(0, address.indexOf(result.name) + result.name.length);
          const location = {
            address: address,
            lnglat: result.lnglat,
          };
          const editMark = vm.$refs.editMark as any;
          if (editMark) {
            editMark.SelectLocation(location);
          }
        }
      });
    },
  };
  private infoWindowContent = ['<div class="infoWindow">',
    '<p><label>年份：</label>{name}</p>',
    '<p><label>旧址：</label>{oldAddress}</p>',
    '<p><label>现址：</label>{address}</p>',
    '<p class="introduce">{introduce}</p>',
  ];

  private created() {
    this.mapHeight = ( window.innerHeight - 110) + 'px';
    this.markListHeight = (window.innerHeight - 300) + 'px';
  }
  private mounted() {
    vm = this;
    let timelineItemId: number = 0;
    this.mapId = parseInt(this.$route.query.id + '');
    if (this.mapId > 0) {
      this.service.Get(this.mapId).then((response: any) => {
        this.data = response;
        timelineItemId = response.timelineItemID;
        // console.log(timelineItemId);
        if (timelineItemId > 0) {
          this.loadTimelineItem(timelineItemId);
        }
      });
    } else {
      timelineItemId = parseInt(this.$route.query.timelineitemid + '');
      if (timelineItemId > 0) {
        this.loadTimelineItem(timelineItemId);
      }
    }
  }
  private loadTimelineItem(timelineItemId: number) {
    this.timelineItemService.Get(timelineItemId).then((response: any) => {
      this.timelineItemData.push(response);
      this.timelineItemIDs.push(timelineItemId);
      this.btnSearch_OnClick();
    });
  }
  private btnMapItem_OnClick(item: MapViewModel) {
    const id: number = item.id!;
    this.selectMap = item;
    if (this.moveMaker) {
      this.moveMaker.setMap(null);
      if (this.isPlayed) {
        this.btnStop_OnClick();
      }
    }
    this.amap.clearMap();
    this.mapId = id;
    this.showEditMark = true;
    this.showMapList = false;
    vm.passedPolyline = new AMap.Polyline({
      map: vm.amap,
      strokeColor: '#AF5',  // 线颜色
      strokeWeight: 6,      // 线宽
    });
    this.loadMark();
  }
  private loadMark() {
    this.markService.GetByMapID(this.mapId).then((response: any) => {
      this.markData = response;
      this.linePath = [];
      const lngLatDict: any = {};
      let key: string = '';
      let index: number = 0;
      let markCount: number = 0;
      // console.log(this.amap);
      this.markData.forEach((item: MarkViewModel) => {
        this.linePath.push([item.lng, item.lat]);
        key = `${item.lng}:${item.lat}`;
        if (lngLatDict[key] === undefined) {
          markCount = 0;
        } else {
          markCount = lngLatDict[key] + 1;
        }
        lngLatDict[key] = markCount;
        const marker: any = new AMap.Marker({
          map: this.amap,
          position: [item.lng, item.lat],
          title: item.name,
          label: {content: item.name, direction: 'bottom', offset: new AMap.Pixel(item.name!.length * -2 , 40 + (markCount * 25))},
          extData: index++,
        });
        marker.on('click', (e: any) => {
          this.lastPathIndex = e.target.F.extData + 1;
          console.log(this.lastPathIndex);
          // console.log(e);
          // const mark = e.target.F.extData;
          // const content = this.infoWindowContent.join('');
          // this.infoWindow.setContent(content.replace('{name}', mark.name)
          //   .replace('{oldAddress}', mark.oldAddress)
          //   .replace('{address}', mark.address)
          //   .replace('{introduce}', (mark.introduce === null ? '' : mark.introduce)));
          // this.infoWindow.open(this.amap, e.lnglat);
          // const editMark = vm.$refs.editMark as any;
          // if (editMark) {
          //   editMark.Edit(mark);
          // }
        });
      });
      if (this.linePath.length > 0) {
        const path: any = new AMap.Polyline({
          map: this.amap,
          showDir: true,
          strokeColor: '#28F',
          strokeWeight: 6,
          path: this.linePath,
        });
        this.moveMaker = new AMap.Marker({
          icon: '../static/people.png',
          autoRotation: false,
          zIndex: 200,
          position: this.linePath[0],
          offset: new AMap.Pixel(-40, -25),
          map: this.amap,
        });
        this.moveMaker.on('moving', (e: any) => {
          this.lastPathIndex = e.passedPath.length - 1;
          this.passedPolyline.setPath(e.passedPath);
        });
        this.moveMaker.on('moveend', () => {
          this.lastPathIndex++;
        });
        this.amap.setFitView();
        this.amap.panBy(-200, 0);
      }
    });
  }
  private btnStart_OnClick() {
    // const move = this.$refs['moveMaker'] as any;
    // console.log(move)
    // console.log(move.$$getInstance());
    if (this.isPlay) {
      this.moveMaker.pauseMove();
    } else {
      if (this.isPlayed) {
        this.moveMaker.resumeMove();
      } else {
        this.moveMaker.moveAlong(this.linePath, this.moveSpeed * 30000);
        this.isPlayed = true;
      }
    }
    this.isPlay = !this.isPlay;
  }
  private btnStop_OnClick() {
    this.isPlay = false;
    this.isPlayed = false;
    this.moveMaker.stopMove();
    this.moveMaker.setPosition(this.linePath[0]);
    this.lastPathIndex = 1;
    this.passedPolyline.setPath([]);
  }
  private btnNext_OnClick() {
    if (this.lastPathIndex < this.linePath.length) {
      this.moveMaker.pauseMove();
      this.isPlay = false;
      this.moveMaker.setPosition(this.linePath[this.lastPathIndex]);
      this.lastPathIndex++;
    }
  }
  private btnPrevious_OnClick() {
    if (this.lastPathIndex > 0) {
      this.moveMaker.pauseMove();
      this.isPlay = false;
      this.moveMaker.setPosition(this.linePath[this.lastPathIndex - 1]);
      this.lastPathIndex--;
    }
  }
  private speed_OnChange() {
    this.btnStop_OnClick();
  }

  private timelineItem_OnSearch(query: string) {
    if (query !== '') {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.timelineItemService.GetByName(query).then((response: any) => {
          this.timelineItemData = response;
        });
        // this.options = this.list.filter(item => {
        //   return item.label.toLowerCase()
        //     .indexOf(query.toLowerCase()) > -1;
        // });
      }, 200);
    } else {
      this.timelineItemData = [];
    }
  }
  private btnSearch_OnClick() {
    this.service.Search({timelineItemIDs: this.timelineItemIDs}, 1).then((response: any) => {
      this.data = response;
      this.showMapList = true;
      this.showEditMap = false;
      this.showEditMark = false;
      if (this.mapId > 0) {
        for (const item of response.list) {
          if (item.id === this.mapId) {
            this.btnMapItem_OnClick(item);
            break;
          }
        }
        this.mapId = 0;
      }
    });
  }
  private Map_OnSave(isCreate: boolean) {
    // if (isCreate) {
    //   this.showEditMap = false;
    //   this.showEditMark = true;
    // }
    this.btnSearch_OnClick();
  }
  private Map_OnCancel() {
    this.showEditMap = false;
    this.showMapList = true;
  }
  private Mark_OnCancel() {
    this.showMapList = true;
    this.showEditMark = false;
    this.linePath = [];
    this.searchMarks = [];
    this.amap.clearMap();
  }
  private Mark_OnSearch(pois: any) {
    // this.searchMarks = pois;
    this.amapOptions.center = [pois[0].lng, pois[0].lat];
    this.amapOptions.zoom = 10;
  }
  private Mark_OnDelete() {
    this.btnMapItem_OnClick(this.selectMap);
  }
  private Mark_OnSave(entity: any) {
    console.log(entity);
    this.btnMapItem_OnClick(this.selectMap);
  }
  private btnMapCreate_OnClick() {
    this.showMapList = false;
    this.showEditMap = true;
    this.$nextTick(() => {
      const editMapData = this.service.NewModel;
      editMapData.timelineItemID = this.timelineItemIDs[0];
      (this.$refs['editMap'] as any).Edit(editMapData);
    });
  }
  private btnMapEdit_OnClick(item: MapViewModel) {
    this.showMapList = false;
    this.showEditMap = true;
    this.$nextTick(() => {
      (this.$refs['editMap'] as any).Edit(item);
    });
    // (this.$refs['editMap'] as any).Edit(item);
  }
  private btnMapDelete_OnClick(item: MapViewModel) {
    MessageBox.confirm('是否删除？', {type: 'warning'})
      .then(() => {
        this.service.Delete(item.id!).then((response: any) => {
          this.$message.success('删除成功！');
          this.btnSearch_OnClick();
        });
      });
  }
}
